<template>
  <div v-redirect-if-no-permission:REGISTERED_CAPTAINS>
    <loading-component :value="loading" />
    <v-layout style="background-color: white; margin-bottom: -10px" justify-end>
      <router-link :to="{ name: 'CreatePriceRules' }">
        <v-btn v-if="this.$store.state.user.roles[0].name != 'Call center'" color="primary">{{ $t("priceRulesPage.newPriceRules") }}</v-btn>
      </router-link>
    </v-layout>
    <data-table
      ref="priceRulesDataTable"
      :url="api.ACTIONS.PRICE_RULES"
      :enable-edit="false"
      :enable-delete="false"
      :enable-add="false"
      perPage="100"
      :fields-hidden-main="[
        'id',
        'pick_up_location_cluster_id',
        'price_per_minute',
        'updated_at',
        'created_at',
        'pull_down_cluster',
        'pull_down_location_cluster_id',
      ]"
      :titles="titles"
      :actions-extra-main="actionsExtraMain"
      :disable-search="false"
    />
  </div>
</template>

<script>
import DataTable from "@/components/monaco/DataTable";
import Search from "@/components/monaco/SearchAgent";
import ConfirmCaptainDialog from "@/components/monaco/input/ConfirmCaptainDialog";
import LoadingComponent from "@/components/LoadingComponent";
import InterviewCreator from "@/components/driver_acquisition/InterviewCreator";

export default {
  name: "Price_Rules",
  title() {
    return this.$t("priceRulesPage.pageTitle");
  },
  components: {
    InterviewCreator,
    LoadingComponent,
    DataTable,
    Search,
    ConfirmCaptainDialog,
  },
  data() {
    return {
      loading: false,
      confirm_dialog: {
        visible: false,
        captain_id: null,
      },
    };
  },
  computed: {
    titles() {
      return {
        price_rule_id: this.$t("priceRulesPage.colId"),
        pull_down_location_cluster_title: this.$t("priceRulesPage.colPullDownCluster"),
        max_price: this.$t("priceRulesPage.colMaxPrice"),
        min_price: this.$t("priceRulesPage.colMinPrice"),
        min_time: this.$t("priceRulesPage.colMinTime"),
      };
    },
    actionsExtraMain() {
      if (this.$store.state.user.roles[0].name == 'Call center') return {};
      return {
        editPriceRules: {
          title: this.$t("priceRulesPage.editAction"),
          icon: "edit",
          action: (item) =>
            this.$router.push({
              name: "EditPriceRules",
              params: { id: item.id },
            }),
        },
        deletePriceRules: {
          title: this.$t("priceRulesPage.deleteAction"),
          icon: "delete_forever",
          action: ({ id }) => {
            this.loading = true;
            this.axios
              .delete(`priceRule/${id}`)
              .then((res) => {
                window.getApp.$emit(
                  "SHOW_TOAST",
                  this.$t("priceRulesPage.toastDeleted"),
                  "green"
                );
                this.$refs.priceRulesDataTable.getData();
              })
              .catch((err) => {
                let response = err.response;
                if (response) {
                  window.getApp.$emit(
                    "SHOW_TOAST",
                    response.data.message,
                    "red"
                  );
                } else {
                  window.getApp.$emit(
                    "SHOW_TOAST",
                    this.$t("priceRulesPage.somethingWentWrong"),
                    "red"
                  );
                }
              })
              .finally(() => (this.loading = false));
          },
        },
      };
    },
  },
};
</script>
